import { ACTION_OUTPUTS, ENROLLED_OBJECT, ENROLLMENT_DATASET, ENROLLMENT_EVENTS, FETCHED_OBJECTS, WORKFLOW_DATA_SOURCES } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
export const isLegacyTokenPrefix = prefixName => {
  if (!prefixName) {
    return true;
  }
  return !(prefixName.includes(ACTION_OUTPUTS) || prefixName.includes(ENROLLED_OBJECT) || prefixName.includes(ENROLLMENT_EVENTS) || prefixName.includes(FETCHED_OBJECTS) || prefixName.includes(WORKFLOW_DATA_SOURCES) || prefixName.includes(ENROLLMENT_DATASET));
};
export const rewriteLegacyPrefix = legacyPrefix => {
  // Only rewrite the first segment of the legacy token
  const [rootPrefix, ...rest] = legacyPrefix.split('.');
  if (!isLegacyTokenPrefix(rootPrefix)) {
    return legacyPrefix;
  }
  return [ENROLLED_OBJECT, ...rest].join('.');
};